
// let baseImgUrl = process.env.NODE_ENV === 'production' ? "https://gf.cleair-cn.com" : "https://https://gf.cleair-cn.com"
// 正式发布后使用 https://test.cqezdj.com 接口nginx转发
let ApiUrl = process.env.NODE_ENV == 'production' ? "https://apicdn.cqezdj.com" : "https://csback.cqezdj.com"
let appid = 'wxae6ac872bb039d07'
// 正式发布后使用 https://mobile.cqezdj.com
let onLineUrl1 = process.env.NODE_ENV == 'production' ? "https://mm.cqezdj.com" : 'https://csnose.cqezdj.com'
let WECHAT_TYPE = 'wechat'
// 测试阶段
// #ifdef H5-TEST
	console.warn("注意当前是测试TEST环境！！！！！！不能直接发布到正式环境！")
	ApiUrl = 'https://jm.cqezdj.com'
	appid = 'wx944af39d9620d37b'
	onLineUrl1 = 'https://dev.cqezdj.com'
	WECHAT_TYPE = 'test'
// #endif

const appIdMap = {
	"wechat": "wxae6ac872bb039d07", // e足到家
	"ezdj":  "wx6dd4c8a27a26c9dc", //  e足SPA
	"test": "wx944af39d9620d37b", // e足SPA服务	测试公众号
}

export let wechatType = WECHAT_TYPE
// uni.setStorageSync('wechatType', WECHAT_TYPE)
export const onLineUrl = onLineUrl1
export const Appid = () => {
	console.log(appIdMap[WECHAT_TYPE] || appIdMap['wechat'])
	return appIdMap[WECHAT_TYPE] || appIdMap['wechat']
}

export const baseApiUrl = ApiUrl
// 企业微信ID
export const companyId = "wwd1b40c0a7b56b8d5"
// 白天客服ID
export const baitianKF = 'https://work.weixin.qq.com/kfid/kfcc9aa634afad3bf47'
export const yewanKF = 'https://work.weixin.qq.com/kfid/kfcc93ed1d975a96cd5'

// 客服电话
export const phoneNumber = "400-880-2575"
// if (process.env.NODE_ENV === 'development') {
//     // TODO
// }
// // uEnvProd
// if (process.env.NODE_ENV === 'production') {
//     // TODO
// }
console.log(process.env)

// 多公众号配置APPid
export const setAppId = (type) => {
	appid = appIdMap[type] || appIdMap['test']
	WECHAT_TYPE = type
	wechatType = type
	uni.setStorageSync('wechatType', type)
	console.warn('当前模式为:'+ type+',Appid为：', appid)
}

export const callPhone = () => {
    uni.makePhoneCall({
        phoneNumber
    });
}

// vip弹窗提醒过期失效
export const vipPopNotShowDay = 7
export const updateText = '新版本已准备好，可随时更新'
